/**
 *
 * @title FormInputControl
 * @description 无状态组件
 *
 */

import React, { Component } from 'react';
import { message } from 'antd';

class FormInputControl extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onChange2 = this.onChange2.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
    }
    componentDidMount() {

        if (this.props.focus) {
            this.focus();
            this.setSelectionRange();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.focus) {
            console.error('=============================FormInputControls.componentDidUpdate', prevProps == this.props, prevProps, this.props)

            this.focus();
            // this.setSelectionRange();
        }
    }
    onChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(e.target.value);
        }
    }
    onChange2 = (e) => {
        if (this.props.onChange) {
            this.props.onChange(e.target.value);
        }
    }
    onFocus = (e) => {
        this.setSelectionRange();
    }
    onBlur = (e) => {
        if (this.props.onBlur) {
            this.props.onBlur(e.target.value);
        }
    }
    onClick = (e) => {
        this.props.onClick && this.props.onClick(e);
    }

    focus() {
        let _self = this;
        if (_self._input) {
            // let _self = this;
            // setTimeout(() => {
            if (_self._input) {
                _self._input.focus();
            } else {
                debugger


            }
            // }, 0)

        }
    }
    setSelectionRange() {
        let _self = this;
        if (_self._input) {
            // let _self = this;
            // setTimeout(() => {
            if (_self._input) {
                _self._input.setSelectionRange(0, this._input.value.length);
            } else {
                debugger
            }
            // }, 0)

        }
    }

    render() {
        let classNames = 'u-form-control ant-input multi-lang';
        if (this.props.className) {
            classNames += ' ' + this.props.className;
        }

        let inputProps = {};
        for (let propKey in this.props) {
            if (['onChange', 'onBlur', 'onClick'].indexOf(propKey) > -1) {
                continue;
            }
            inputProps[propKey] = this.props[propKey];
        }
        console.error('this.props and inputProps:', this.props, inputProps);
        return (
            <input {...inputProps} ref={(input) => { this._input = input }} className={classNames} onChange={this.onChange} onChange={this.onChange2} onFocus={this.onFocus} onBlur={this.onBlur} onClick={this.onClick} />
            // <input {...this.props} className={classNames} onChange={this.onChange} onClick={this.onClick} />
        )
    }
}

export default FormInputControl;
